import { datadogRum } from '@datadog/browser-rum';
import { toast } from '@side/pantry';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { InteractionType } from '@/common/types/interaction';
import { TXM_BUYERS_PATH } from '@/constants';
import { ReferralError } from '@/views/Referrals/types';
import {
  getReferralErrorCode,
  getReferralErrorMessage,
} from '@/views/Referrals/utils';
import { coreApi } from '$api-clients';

export function useCreateBuyerAgreementButton(referralId: string) {
  const [creatingAgreement, setCreatingAgreement] = useState(false);
  const router = useRouter();

  const onClick = async () => {
    setCreatingAgreement(true);

    try {
      const { data, error } = await coreApi.POST('/interactions', {
        body: {
          type: 'clientGroup',
          interaction: { referralId },
        },
      });

      if (error !== undefined) {
        const referralErrorCode = getReferralErrorCode(error);
        if (referralErrorCode) {
          throw new ReferralError(
            getReferralErrorMessage(
              referralErrorCode,
              InteractionType.clientGroup,
            ),
          );
        }
        throw new Error('Failed to create client group');
      }

      await router.push(`${TXM_BUYERS_PATH}/${data.id}/buyer-agreement`);

      toast('success', 'Buyer created successfully');
    } catch (err) {
      datadogRum.addError(err);

      const errMessage =
        err instanceof ReferralError
          ? err.message
          : 'Creating buyer agreement failed. Please try again or contact Side support for assistance.';

      toast('error', errMessage, {
        showCloseButton: true,
      });

      setCreatingAgreement(false);
    }
  };

  return {
    buttonText: 'Buyer Agreement',
    onClick,
    disabled: creatingAgreement,
  };
}
